import { Flex } from 'rebass';

import useCart from 'hooks/usecart';
import {
  ORDER_TYPE_DOWNLOAD,
  ORDER_TYPE_SELECTION,
} from 'components/cartprovider';
import CheckoutDownload from 'components/checkoutdownload';
import CheckoutSelection from 'components/checkoutselection';

export default function Checkout({ studio }) {
  const [cart] = useCart();

  return (
    <>
      <Flex
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          top: 0,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Flex
          sx={{
            width: 300,
            maxWidth: '100%',
            minHeight: 300,
            maxHeight: '100%',
            backgroundColor: 'white',
            boxShadow: 'large',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 3,
          }}
        >
          {cart.orderType === ORDER_TYPE_DOWNLOAD && (
            <CheckoutDownload studio={studio} />
          )}
          {cart.orderType === ORDER_TYPE_SELECTION && (
            <CheckoutSelection studio={studio} />
          )}
        </Flex>
      </Flex>
    </>
  );
}
